export default "__VITE_PUBLIC_ASSET__9ca14873__"